/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReportIncidentComponent } from './components/reportincident.component';
import { RouterModule } from '@angular/router';
import { ReportIncidentService } from './services/reportincident.service';
import { RequestService } from './services/requestservice';
import { ReportIncidentRoutingModule } from './reportincident-routing.module';
import { AdditionalinfoModule } from '../../shared/module/additionalinfo.module';
import { SpinnerModule } from '../../../../shared/spinner/spinner.module';
import { ContactinfoModule } from '../../shared/module/contactinfo.module';
import { ItemSelectionModule } from '../../shared/module/itemselection.module';
import { FileUploadModule } from '../../../../shared/fileupload/fileupload.module';
import { TinymceModule } from '../../../../shared/tinymce/tinymce.module';
import { CustomfieldsModule } from '../../shared/module/customfields.module';
import { CustomerPreferenceService } from '../../../preference/customerpreference.service';
import { UIMessageService } from '../../shared/services/uimessages.service';
import { RequestDetailService } from '../../requests/services/request-detail.service';
import { RequestslistService } from '../../requests/services/requestslist.service';


@NgModule({
  imports: [
    CommonModule,
    ReportIncidentRoutingModule,
    TranslateModule,
    FormsModule ,
    ReactiveFormsModule,
    AdditionalinfoModule,
    SpinnerModule,
    ContactinfoModule,
    ItemSelectionModule,
    FileUploadModule,
    TinymceModule,
    CustomfieldsModule,
  ],

  declarations: [ ReportIncidentComponent ],
  providers: [ ReportIncidentService, RequestService , CustomerPreferenceService, UIMessageService,
    RequestDetailService, RequestslistService],
    exports: [ ReportIncidentComponent, CommonModule, RouterModule ]
})
export class ReportIncidentModule { }
